export default defineNuxtRouteMiddleware((to, _) => {
  if (!to.matched.length && to.path === '/welcome') {
    return '/';
  }
});
